$(document).ready(function(){
    $('.product-form__submit[name="add"]').on('click', function (e) {
        e.preventDefault();
        var qty = $('.cstm-packqty input[name="pack"]:checked').val();
        var proId = $('.product-form form input[name="id"]').val();
        console.log(proId, qty);
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
                id: proId,
                quantity: qty
            },
            success: function(response) {
                console.log("Product added to cart", response);
                window.location.href = '/cart';
            },
            error: function(xhr) {
                console.log("Error:", xhr.responseJSON);
            }
        });
    });

    $('.cstm-addon_add').on('click', function (e) {
        e.preventDefault();
        var proId = $('.product-form form input[name="id"]').val();
        var items = [];
        items.push({
            id: proId,
            quantity: 1
        });
        $('.fbt-item input[type="checkbox"]:checked').each(function () {
            items.push({
                id: $(this).val(),
                quantity: 1
            });
        });
        console.log(items);
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                items: items
            }),
            success: function (response) {
                console.log('Products added:', response);
                window.location.href = '/cart';
            },
            error: function (xhr) {
                console.log(xhr.responseJSON);
            }
        });
    });

    /**************/
    function update_price() {
        var price_1 = parseFloat($('.cstm-getpricewithcurrenty').data('price'));
        if (isNaN(price_1)) return;
        var pack1 = price_1 / 100;
        var pack2 = ((price_1 * 2) * 0.8) / 100;
        $('.pack-price-1').html('€' + pack1.toFixed(2));
        $('.pack-price-2').html('€' + pack2.toFixed(2));
    }
    update_price();
    $(document).on('change', '.cstm-updateprice input[type="radio"]', function () {
        setTimeout(function () {
            update_price();
        }, 1000);
    });

    $('.cstm-readmore_less-btn').click(function(e){
        e.preventDefault();
        var pro_desH = $('.cstm-readmoresection').height();
        if(pro_desH == 413 || pro_desH <= 413){
            $('.cstm-readmoresection').css('height', 'auto');
            $(this).text('Read less');
        }else{
            $('.cstm-readmoresection').css('height', '413');
            $(this).text('Read more');
        }
        console.log(pro_desH);
    })
    /*************/ 

});